module.exports = __webpack_public_path__ + "static/media/teilnahme_true_passive.2dca2d34.jpg";